import { Container } from "react-bootstrap";
import { Col, Row, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import BackArrow from "../../components/backArrow";
import { useRef, useState, useEffect, useMemo } from "react";
import PersonalImage from "../../helpers/fileUpload";
import Card from "react-bootstrap/Card";
import SearchIcon from "@mui/icons-material/Search";
import { images } from "../../constants";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Measurementunit, currencies } from "../../constants/jsonConstant";
import { saleoffer, salepromotion } from "../../constants/jsonConstant";
import { getAsset } from "../../helpers/helper";
import { Formik } from "formik";
import * as Yup from "yup";
import { useGetWorldCitiesQuery } from "../../features/api/worldCitiesApiSlice";

const Restaurantform = ({
  btntext,
  handlevalue,
  Handledata,
  Mydata,
  userDatahandler,
  shopCategory,
  shopCategorytwo,
  updatedata,
  updateDatahandler,
  getInputProps,
  getRootProps,
  displayimg,
  setDisplayimg,
  id,
  isUploading,
  uploadProgress,
  fooddata,
  setFooddata,
}) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // Refs for input fields
  const dishnameRef = useRef(null);
  const priceRef = useRef(null);
  const preparationTimeRef = useRef(null);
  const contactRef = useRef(null);
  const descriptionRef = useRef(null);

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const { data: rawCities = [] } = useGetWorldCitiesQuery();
  const [selectedCountry, setSelectedCountry] = useState(
    updatedata?.country || fooddata?.country || "",
  );
  const [selectedstateone, setSelectedstateone] = useState(
    updatedata?.state || fooddata?.state || "",
  );
  const [selectedcity, setSelectedcity] = useState(
    updatedata?.city || fooddata?.city || "",
  );

  useEffect(() => {
    const c = updatedata?.country || fooddata?.country || "";
    const s = updatedata?.state || fooddata?.state || "";
    const ct = updatedata?.city || fooddata?.city || "";
    if (c) setSelectedCountry(c);
    if (s) setSelectedstateone(s);
    if (ct) setSelectedcity(ct);
  }, [
    updatedata?.country,
    updatedata?.state,
    updatedata?.city,
    fooddata?.country,
    fooddata?.state,
    fooddata?.city,
  ]);

  useEffect(() => {
    // Clear input fields on mount to prevent autofill
    if (dishnameRef.current)
      dishnameRef.current.value = updatedata?.dishname || "";
    if (priceRef.current) priceRef.current.value = updatedata?.price || "";
    if (preparationTimeRef.current)
      preparationTimeRef.current.value = updatedata?.preparationTime || "";
    if (contactRef.current)
      contactRef.current.value = updatedata?.contact || "";
    if (descriptionRef.current)
      descriptionRef.current.value = updatedata?.description || "";
  }, [updatedata]);

  const country = useMemo(() => {
    const set = new Set();
    rawCities.forEach((item) => {
      if (item && item.country) set.add(item.country);
    });
    return Array.from(set).sort();
  }, [rawCities]);

  const getState = useMemo(() => {
    if (!selectedCountry) return [];
    const set = new Set();
    rawCities.forEach((item) => {
      if (
        item &&
        item.country &&
        item.country.toLowerCase() === selectedCountry.toLowerCase() &&
        item.subcountry
      ) {
        set.add(item.subcountry);
      }
    });
    return Array.from(set).sort();
  }, [rawCities, selectedCountry]);

  const getcity = useMemo(() => {
    if (!selectedCountry || !selectedstateone) return [];
    const set = new Set();
    rawCities.forEach((item) => {
      if (
        item &&
        item.country &&
        item.country.toLowerCase() === selectedCountry.toLowerCase() &&
        item.subcountry &&
        item.subcountry.toLowerCase() === selectedstateone.toLowerCase() &&
        item.name
      ) {
        set.add(item.name);
      }
    });
    return Array.from(set)
      .sort()
      .map((name) => ({ name }));
  }, [rawCities, selectedCountry, selectedstateone]);

  const validationSchema = Yup.object({
    dishname: Yup.string().required("Dish name is required*"),
    categoryid: Yup.string().required("Category is required*"),
    subCategoryid: Yup.string().required("Subcategory is required*"),
    price: Yup.string().required("Price is required*"),
    currency: Yup.string().required("Currency is required*"),
    country: Yup.string().required("Country is required*"),
    state: Yup.string().required("State is required*"),
    city: Yup.string().required("City is required*"),
    description: Yup.string().required("Description is required*"),
    contact: Yup.string()
      .required("Contact is required*")
      .matches(/^[0-9+\-\s()]{8,}$/, "Please enter a valid contact number"),
  });

  return (
    <>
      {selectedImage && <PersonalImage image={selectedImage} />}
      <Container>
        <Row>
          <div className="screenHeight d-flex justify-content-center align-items-center">
            <Col lg={10} md={12} sm={12} xs={12} className="Form-Shadow">
              <Row>
                <Col className="">
                  <div className="arrowback ps-3">
                    <BackArrow
                      back="/RestaurantAlldata"
                      black="black"
                      mystyle="ps-3 p-1"
                    />
                  </div>
                </Col>
              </Row>
              <div className="p-4">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    dishname: updatedata?.dishname || fooddata?.dishname || "",
                    categoryid:
                      updatedata?.category || fooddata?.category || "",
                    subCategoryid:
                      updatedata?.subCategory || fooddata?.subCategory || "",
                    price: updatedata?.price || fooddata?.price || "",
                    currency: updatedata?.currency || fooddata?.currency || "",
                    preparationTime:
                      updatedata?.preparationTime ||
                      fooddata?.preparationTime ||
                      "",
                    contact: updatedata?.contact || fooddata?.contact || "",
                    country:
                      updatedata?.country ||
                      fooddata?.country ||
                      selectedCountry ||
                      "",
                    state:
                      updatedata?.state ||
                      fooddata?.state ||
                      selectedstateone ||
                      "",
                    city:
                      updatedata?.city || fooddata?.city || selectedcity || "",
                    salesPromotion:
                      updatedata?.salesPromotion ||
                      fooddata?.salesPromotion ||
                      "",
                    specialOffers:
                      updatedata?.specialOffers ||
                      fooddata?.specialOffers ||
                      "",
                    description:
                      updatedata?.description || fooddata?.description || "",
                  }}
                  validateOnBlur={false}
                  validationSchema={validationSchema}
                  onSubmit={(values) => {
                    // No-op since submission is handled by userDatahandler or updateDatahandler
                  }}
                >
                  {({
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    values,
                    setFieldValue,
                    errors,
                    touched,
                    isValid,
                    dirty,
                  }) => (
                    <Form
                      autoComplete="off"
                      onSubmit={(e) => {
                        handleSubmit(e);
                        btntext === "Post"
                          ? userDatahandler(e)
                          : updateDatahandler(e);
                      }}
                    >
                      {/* Hidden input to trick autofill */}
                      <input
                        type="text"
                        style={{ display: "none" }}
                        autoComplete="off"
                      />
                      <Row className="pt-2 pb-2 px-3">
                        <Col md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">
                            Dish Name
                          </Form.Label>
                          <Form.Control
                            placeholder="Name"
                            className="input-style form-control-seller placeholderClorset"
                            name="dishname"
                            onChange={(e) => {
                              handlevalue(e);
                              handleChange(e);
                            }}
                            defaultValue={updatedata?.dishname}
                            autoComplete="off"
                          />
                          {errors.dishname && touched.dishname ? (
                            <div>
                              <p className="error_text_color">
                                {errors.dishname}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3} className="">
                          <Form.Label className="custm-lble">
                            Category
                          </Form.Label>
                          <Form.Select
                            className="input-style form-control-seller"
                            aria-label="Default select example"
                            name="categoryid"
                            onChange={(e) => {
                              Handledata(e);
                              handleChange(e);
                            }}
                            autoComplete="off"
                          >
                            {updatedata?.category?.length > 0 ? (
                              <option>{updatedata?.category}</option>
                            ) : (
                              <option disabled selected>
                                Select-Category
                              </option>
                            )}
                            {shopCategory?.map((category) => (
                              <option
                                key={category._id}
                                value={`${category?._id}.${category?.name}`}
                              >
                                {category?.name}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.categoryid && touched.categoryid ? (
                            <div>
                              <p className="error_text_color">
                                {errors.categoryid}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3} className="">
                          <Form.Label className="custm-lble">
                            SubCategory
                          </Form.Label>
                          <Form.Select
                            onChange={(e) => {
                              Handledata(e);
                              handleChange(e);
                            }}
                            onClick={Mydata}
                            name="subCategoryid"
                            className="input-style form-control-seller"
                            aria-label="Default select example"
                            autoComplete="off"
                          >
                            {updatedata?.subCategory?.length > 0 ? (
                              <option>{updatedata?.subCategory}</option>
                            ) : (
                              <option disabled selected>
                                Select-SubCategory
                              </option>
                            )}
                            {shopCategorytwo?.map((subcategory) => (
                              <option
                                key={subcategory._id}
                                value={`${subcategory?._id}.${subcategory?.name}`}
                              >
                                {subcategory?.name}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.subCategoryid && touched.subCategoryid ? (
                            <div>
                              <p className="error_text_color">
                                {errors.subCategoryid}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">Price</Form.Label>
                          <Form.Control
                            placeholder="PKR"
                            name="price"
                            className="input-style form-control-seller placeholderClorset"
                            type="number"
                            onChange={(e) => {
                              handlevalue(e);
                              handleChange(e);
                            }}
                            defaultValue={updatedata?.price}
                            autoComplete="off"
                          />
                          {errors.price && touched.price ? (
                            <div>
                              <p className="error_text_color">{errors.price}</p>
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <Row className="pt-2 pb-2 px-3">
                        <Col md={3} lg={3} xl={3} className="">
                          <Form.Label className="custm-lble">
                            Currency
                          </Form.Label>
                          <Form.Select
                            placeholder="Select Currency"
                            aria-label="Default select example"
                            name="currency"
                            className="input-style form-control-seller"
                            onChange={(e) => {
                              handlevalue(e);
                              handleChange(e);
                            }}
                            autoComplete="off"
                          >
                            {updatedata?.currency?.length > 0 ? (
                              <option>{updatedata?.currency}</option>
                            ) : (
                              <option disabled selected>
                                Select Currency
                              </option>
                            )}
                            {currencies.map((e) => (
                              <option key={e.id}>
                                {e.abbreviation} {e.name}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.currency && touched.currency ? (
                            <div>
                              <p className="error_text_color">
                                {errors.currency}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">
                            Preparation Time
                          </Form.Label>
                          <Form.Control
                            placeholder="Enter Preparation Time"
                            className="input-style form-control-seller placeholderClorset"
                            name="preparationTime"
                            onChange={(e) => {
                              handlevalue(e);
                              handleChange(e);
                            }}
                            defaultValue={updatedata?.preparationTime}
                            autoComplete="off"
                          />
                          {errors.preparationTime && touched.preparationTime ? (
                            <div>
                              <p className="error_text_color">
                                {errors.preparationTime}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">
                            Contact
                          </Form.Label>
                          <Form.Control
                            placeholder="Contact"
                            className="input-style form-control-seller placeholderClorset"
                            name="contact"
                            onChange={(e) => {
                              handlevalue(e);
                              handleChange(e);
                            }}
                            defaultValue={updatedata?.contact}
                            autoComplete="off"
                          />
                          {errors.contact && touched.contact ? (
                            <div>
                              <p className="error_text_color">
                                {errors.contact}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">
                            Country*
                          </Form.Label>
                          <Form.Select
                            className="form-select-seller"
                            name="country"
                            value={values.country || selectedCountry || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setSelectedCountry(val);
                              setSelectedstateone("");
                              setSelectedcity("");
                              setFieldValue("country", val);
                              setFieldValue("state", "");
                              setFieldValue("city", "");
                              handlevalue(e);
                              handleChange(e);
                            }}
                            autoComplete="off"
                          >
                            <option value="">Select-Country</option>
                            {country.map((c) => (
                              <option key={c} value={c}>
                                {c}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.country && touched.country ? (
                            <div>
                              <p className="error_text_color">
                                {errors.country}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <Row className="pt-2 pb-2 px-3">
                        <Col md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">State*</Form.Label>
                          <Form.Select
                            className="form-select-seller"
                            name="state"
                            value={values.state || selectedstateone || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setSelectedstateone(val);
                              setSelectedcity("");
                              setFieldValue("state", val);
                              setFieldValue("city", "");
                              handlevalue(e);
                              handleChange(e);
                            }}
                            autoComplete="off"
                          >
                            <option value="">Select-State</option>
                            {getState.map((s) => (
                              <option key={s} value={s}>
                                {s}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.state && touched.state ? (
                            <div>
                              <p className="error_text_color">{errors.state}</p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">City</Form.Label>
                          <Form.Select
                            className="form-select-seller"
                            name="city"
                            value={values.city || selectedcity || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setSelectedcity(val);
                              setFieldValue("city", val);
                              handlevalue(e);
                              handleChange(e);
                            }}
                            autoComplete="off"
                          >
                            <option value="">Select-City</option>
                            {getcity.map((c) => (
                              <option key={c.name} value={c.name}>
                                {c.name}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.city && touched.city ? (
                            <div>
                              <p className="error_text_color">{errors.city}</p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3} className="">
                          <Form.Label className="custm-lble">
                            Sales Promotion
                          </Form.Label>
                          <Form.Select
                            className="input-style form-control-seller"
                            aria-label="Default select example"
                            name="salesPromotion"
                            onChange={(e) => {
                              handlevalue(e);
                              handleChange(e);
                            }}
                            autoComplete="off"
                          >
                            {updatedata?.salesPromotion?.length > 0 ? (
                              <option>{updatedata?.salesPromotion}</option>
                            ) : (
                              <option disabled selected>
                                Select Sales
                              </option>
                            )}
                            {salepromotion.map((e) => (
                              <option key={e.label}>{e.label}</option>
                            ))}
                          </Form.Select>
                          {errors.salesPromotion && touched.salesPromotion ? (
                            <div>
                              <p className="error_text_color">
                                {errors.salesPromotion}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} lg={3} xl={3} className="">
                          <Form.Label className="custm-lble">
                            Special Offers
                          </Form.Label>
                          <Form.Select
                            className="input-style form-control-seller"
                            aria-label="Default select example"
                            name="specialOffers"
                            onChange={(e) => {
                              handlevalue(e);
                              handleChange(e);
                            }}
                            autoComplete="off"
                          >
                            {updatedata?.specialOffers?.length > 0 ? (
                              <option>{updatedata?.specialOffers}</option>
                            ) : (
                              <option disabled selected>
                                Select Offers
                              </option>
                            )}
                            {saleoffer.map((e) => (
                              <option key={e.label}>{e.label}</option>
                            ))}
                          </Form.Select>
                          {errors.specialOffers && touched.specialOffers ? (
                            <div>
                              <p className="error_text_color">
                                {errors.specialOffers}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <div className="ps-3 pe-3 pt-4">
                        <Form.Label className="custm-lble">
                          Description
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="description"
                          className="input-style placeholderClorset"
                          placeholder="description"
                          onChange={(e) => {
                            handlevalue(e);
                            handleChange(e);
                          }}
                          defaultValue={updatedata?.description}
                          autoComplete="off"
                        />
                        {errors.description && touched.description ? (
                          <div>
                            <p className="error_text_color">
                              {errors.description}
                            </p>
                          </div>
                        ) : null}
                      </div>
                      <div className="d-flex justify-content-between pt-2">
                        <Col lg="9" className="me-auto">
                          <Row>
                            <Col lg={2} className="mt-2 ms-3">
                              <Card
                                style={{
                                  width: "6rem",
                                  height: "6rem",
                                  position: "relative", // ✅ to position loader
                                }}
                                {...getRootProps()}
                                className="dropzone"
                              >
                                {/* Show loader if uploading */}
                                {isUploading ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      background: "rgba(255,255,255,0.7)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      borderRadius: "0.5rem",
                                    }}
                                  >
                                    <div
                                      className="spinner-border text-primary"
                                      style={{
                                        width: "1.5rem",
                                        height: "1.5rem",
                                      }}
                                      role="status"
                                    ></div>
                                    <small className="mt-1">
                                      {uploadProgress}%
                                    </small>
                                  </div>
                                ) : (
                                  <>
                                    <Card.Img
                                      className="imet-fit"
                                      src={images.AddImage}
                                    />
                                    <Card.Body>
                                      <input
                                        type="file"
                                        id="file"
                                        style={{ display: "none" }}
                                        {...getInputProps()}
                                        multiple
                                        autoComplete="off"
                                      />
                                    </Card.Body>
                                  </>
                                )}
                              </Card>
                            </Col>

                            {displayimg?.length > 0 && (
                              <Col lg={7} className="mt-1 d-flex">
                                {displayimg.map((image, index) => (
                                  <Card
                                    key={index}
                                    className="me-2 mt-1"
                                    style={{
                                      width: "6rem",
                                      height: "6rem",
                                      border: "2px solid",
                                      position: "relative",
                                    }}
                                  >
                                    <Card.Img
                                      className="imet-fit upload-img mt-0"
                                      src={getAsset(image)}
                                      alt=""
                                      crossOrigin="anonymous"
                                    />
                                    <div
                                      className="close-btnone"
                                      onClick={() => removeImage(index)}
                                    >
                                      <ClearIcon />
                                    </div>
                                  </Card>
                                ))}
                              </Col>
                            )}
                          </Row>
                        </Col>

                        <div className="d-flex align-items-end pb-3 pe-3">
                          <div className="btns">
                            <button
                              type="button"
                              className="btn1"
                              onClick={() => navigate(-1)}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn2"
                              onClick={
                                btntext === "Post"
                                  ? userDatahandler
                                  : updateDatahandler
                              }
                            >
                              {btntext}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Col>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Restaurantform;
